import { OutletDetails, OutletListItem } from '@ancon/wildcat-types'

export default function getSimpleOutletListItemByOutletDetails(
  outlet: OutletDetails,
) {
  // Added only the properties currently needed
  return {
    id: outlet.id,
    name: outlet.name,
    urlSlug: outlet.urlSlug,
  } as OutletListItem
}
